import {API_SERVERLESS, getFetch} from '~commonApi';

export function apiBackOfficeSearchClients(criteria = '') {
    return getFetch(`${API_SERVERLESS}/backOffice/v3/clientSearch?searchCriteria=${criteria}`, true);
}

export function apiBackOfficeGetClient(clientCode) {
    return getFetch(`${API_SERVERLESS}/backOffice/v3/client/${clientCode}`, true);
}
